__turbopack_context__.v({
  "close": "SearchInput-module-scss-module__4MQCIW__close",
  "input": "SearchInput-module-scss-module__4MQCIW__input",
  "wrapper": "SearchInput-module-scss-module__4MQCIW__wrapper",
});
